<template>
  <b-row v-if="show">
    <b-col cols="12" sm="8">
      <b-alert
          show
          :style="`background-color: ${selected.backgroundColor}; border-color: ${selected.borderColor}; color:${selected.color};`">
        <b-row class="">
          <b-col
              v-if="validIsInformative"
              cols="1"
              class="center"
              style="margin: auto;">
            <i
                :class="`icon-${selected.icon} text-${selected.borderColor} mr-1`"
                :style="`background-color: ${selected.backgroundColor}; border-color: ${selected.borderColor}; color: ${selected.borderColor}; font-size: 1.73em;`" />
          </b-col>
          <b-col>
            <slot name="body">
            </slot>
          </b-col>
        </b-row>
      </b-alert>
    </b-col>
    <b-col
        v-if="includeImg"
        cols="12" sm="8">
      <slot name="img">
      </slot>
    </b-col>
  </b-row>

</template>

<script>
export default {
    name: 'AlertV2',
    props: {
      type: String,
      show: Boolean,
      includeImg: Boolean
    },
    computed: {
      /**
       * Opcion selecionada
       */
      selected () {
          if (this.listOptions[this.type]) {
              return this.listOptions[this.type]
          }
          return this.listOptions['warning']
      },
      /**
       * Valida si es informativo para mostrar el icono
       */
      validIsInformative () {
        return this.type !== 'informative'
      },
      /**
       * Lista de opciones permitidas
       */
      listOptions () {
          return {
              warning: {
                  icon: 'warning',
                  backgroundColor: '#FFFBE6',
                  borderColor: '#E56401',
                  color: '#000000'
              },
              danger: {
                icon: 'warning',
                backgroundColor: '#FFF1F0',
                borderColor: '#DA1414',
                color: '#000000'
              },
              informative : {
                icon: false,
                backgroundColor: '#FFD97C',
                borderColor: '#E56401',
                color: '#000000'
              }
          }
      }
    }
}    
</script>

<style scoped>
    i.circle {
      display: inline-block;
      border-radius: 60px;
      box-shadow: 0 0 2px #888;
    }
    .center {
        text-align: center;
    }
</style>